import { CommonModule } from '@angular/common';
import { Component, Inject, Input, LOCALE_ID } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { RouterModule } from '@angular/router';
import { EnvironmentService, EnvironmentSettings } from 'src/app/core/services/environment/environment.service';
import { NavigationService } from 'src/app/core/services/navigation/navigation.service';

@Component({
    selector: 'qo-try-and-book',
    templateUrl: './try-and-book.component.html',
    imports: [CommonModule, RouterModule, MatRippleModule]
})
export class TryAndBookComponent {

    @Input() halign: string = "center";

    environmentSettings: EnvironmentSettings;
    NavigationService = NavigationService;

    constructor(environmentService: EnvironmentService, @Inject(LOCALE_ID) public locale: string) {
        this.environmentSettings = environmentService.settings;
    }
}
